const IS_DEV = process.env.NODE_ENV !== 'production'

export const logger = {
  debug(...args: unknown[]): void {
    if (IS_DEV) {
      // eslint-disable-next-line no-console
      console.debug('[analytics]', ...args)
    }
  },
}
